// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.playerCard_playerCard__4Ayao{
    display: flex;
    flex-direction: column;
    border-radius: 1px;
    border: 1px solid #297FB0;
    width: 300px;
    max-height: 345px;
    background: #e4eaee;
    text-decoration: none;
    border-radius: 25px;

    >img {
        border-top-right-radius: 25px;
        border-top-left-radius: 25px;
        height: 300px;
        width: 100%;
        object-fit: cover;
    }

    .playerCard_playerInfo__iNy9W {
        width: 100%;
        height: 45px;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 10px;

        .playerCard_name__6IYxF {
            color: #11507B;
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }

        .playerCard_enName__7ym8V {
            color: rgba(17, 80, 123, 0.75);
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            margin-bottom: 7px;
        }

        .playerCard_country__vfydM {
            color: #11507B;
            font-size: 12px;
            font-style: normal;
            font-weight: 300;
            line-height: normal;
        }
    }
}`, "",{"version":3,"sources":["webpack://./src/widgets/players-creation-form/ui/playerCard.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;;IAEnB;QACI,6BAA6B;QAC7B,4BAA4B;QAC5B,aAAa;QACb,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,uBAAuB;QACvB,mBAAmB;QACnB,SAAS;;QAET;YACI,cAAc;YACd,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,mBAAmB;QACvB;;QAEA;YACI,8BAA8B;YAC9B,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,mBAAmB;YACnB,kBAAkB;QACtB;;QAEA;YACI,cAAc;YACd,eAAe;YACf,kBAAkB;YAClB,gBAAgB;YAChB,mBAAmB;QACvB;IACJ;AACJ","sourcesContent":[".playerCard{\n    display: flex;\n    flex-direction: column;\n    border-radius: 1px;\n    border: 1px solid #297FB0;\n    width: 300px;\n    max-height: 345px;\n    background: #e4eaee;\n    text-decoration: none;\n    border-radius: 25px;\n\n    >img {\n        border-top-right-radius: 25px;\n        border-top-left-radius: 25px;\n        height: 300px;\n        width: 100%;\n        object-fit: cover;\n    }\n\n    .playerInfo {\n        width: 100%;\n        height: 45px;\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n        gap: 10px;\n\n        .name {\n            color: #11507B;\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 700;\n            line-height: normal;\n        }\n\n        .enName {\n            color: rgba(17, 80, 123, 0.75);\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: normal;\n            margin-bottom: 7px;\n        }\n\n        .country {\n            color: #11507B;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 300;\n            line-height: normal;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"playerCard": `playerCard_playerCard__4Ayao`,
	"playerInfo": `playerCard_playerInfo__iNy9W`,
	"name": `playerCard_name__6IYxF`,
	"enName": `playerCard_enName__7ym8V`,
	"country": `playerCard_country__vfydM`
};
export default ___CSS_LOADER_EXPORT___;
